<template>
  <div>
    <div class="panel-heading d-flex align-center py-2">
      <h4
        class="panel-title"
        style="display: flex; align-items: center"
      >
        <div
          class="my-btn grey darken-1 mr-3"
          style="font-size: 1.2rem"
          @click="$router.push('/global-website-group')"
        >
          <i class="fa fa-arrow-left mr-1"></i>
          Back
        </div>
        <span
          style="color: tomato; font-weight: bold"
          class="mr-1"
        >
          {{ apiData.name }}
        </span>
        Websites (App)
      </h4>

      <div style="text-align: end">
        <v-btn
          color="primary"
          style="height: auto;"
          depressed
          @click="addNew()"
        >
          Add New Global Website
        </v-btn>
      </div>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >

      <div class="row">
        <div
          v-for="(data, index) in apiData.details"
          :key="index"
          class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3"
        >
          <div
            style="border: 1px solid #ccc; border-radius: 1rem"
            class="pb-2"
          >
            <div style="width: 100%; height: 150px">
              <a
                :href="data.url"
                target="_blank"
              >
                <img
                  :src="`${$_image_path()}${data.logo}`"
                  alt="Logo"
                  width="100%"
                  height="100%"
                  style="border-radius: 1rem; object-fit: contain"
                />
              </a>
            </div>
            <div
              style="font-size: 1.5rem; opacity: 0.7"
              class="px-2 py-1"
            >
              #{{ data.order }}

              <span
                v-if="data.warehouse"
                class="label bg-grey-800 ml-2"
                style="border-radius: 0.5rem; text-transform: none"
              >
                {{ data.warehouse ? data.warehouse.country : '' }}
              </span>

              <span
                v-if="!data.is_active"
                class="label bg-orange-800 ml-2"
                style="border-radius: 0.5rem; text-transform: none"
              >Inactive</span>
            </div>
            <div class="px-2">
              <div style="display: inline">
                <div
                  style="display: inline-block"
                  class="mr-4"
                >
                  <div
                    class="my-btn blue"
                    @click="editRow(data)"
                  >
                    Edit
                  </div>
                </div>

                <div style="display: inline-block">
                  <div
                    class="my-btn error"
                    @click="deleteRow(data.global_website_id)"
                  >
                    Delete
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <add-edit-global-website
      :addEditGlobalWebsiteModal="addEditGlobalWebsiteModal"
      :form="form"
      :warehouses="warehouses"
      :isUpdate="isUpdate"
      @close="addEditGlobalWebsiteModal = false"
      @resetTable="getData()"
    />
  </div>
</template>

<script>
import Axios from 'axios'
import addEditGlobalWebsite from './addEditGlobalWebsite.vue'
import swal from 'sweetalert'

export default {
  components: { addEditGlobalWebsite },
  data() {
    return {
      apiData: { details: [] },
      warehouses: [],
      addEditGlobalWebsiteModal: false,
      isUpdate: false,
      form: {}
    }
  },

  mounted() {
    this.getData()
    this.getWarehouses()
  },

  methods: {
    getWarehouses() {
      let token = localStorage.getItem('access_token')
      Axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    addNew() {
      this.isUpdate = false
      this.form = {
        global_website_group_id_fk: this.apiData.global_website_group_id,
        order: 1,
        logoUrl: null,
        logo: null,
        url: null
      }
      this.addEditGlobalWebsiteModal = true
    },

    editRow(data) {
      this.form = {
        ...data,
        logoUrl: this.$_image_path() + data.logo,
        logo_updated: false
      }
      this.isUpdate = true
      this.addEditGlobalWebsiteModal = true
    },

    deleteRow(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          Axios.delete(`api/global-website/${id}`, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
            this.getData()
            swal({
              title: 'Deleted successfully',
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch((error) => {
            swal('Error', error.response.data.message, 'error')
          })
        }
      })
    },

    getData() {
      var token = localStorage.getItem('access_token')

      let queryParams = {
        global_website_group_id: this.$route.params.id
      }

      Axios.get('api/global-website', {
        params: queryParams,
        headers: { Authorization: 'Bearer ' + token }
      }).then(res => {
        this.apiData = res.data
      })
    }
  }
}
</script>

<style  scoped>
.my-btn {
  color: #fff;
  border-radius: 0.5rem;
  display: inline-block;
  text-align: center;
  padding: 4px 10px;
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/globalWebsite/globalWebsite.vue